import { render, staticRenderFns } from "./fball-text.vue?vue&type=template&id=0b3e76c8&scoped=true"
import script from "./fball-text.vue?vue&type=script&lang=js"
export * from "./fball-text.vue?vue&type=script&lang=js"
import style0 from "./fball-text.vue?vue&type=style&index=0&id=0b3e76c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3e76c8",
  null
  
)

export default component.exports